module.exports = __webpack_public_path__ + "img/paracord1.cfcd987c.jpg";